import { render, staticRenderFns } from "./ReversalPage.vue?vue&type=template&id=b8bb3f00&"
import script from "./ReversalPage.vue?vue&type=script&lang=js&"
export * from "./ReversalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports